import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import useOnClickOutside from 'use-onclickoutside';
import { ButtonWithDropdown } from '@grandvisionhq/elements';
import { PackageQuantityItem } from './components/PackageQuantityItem/PackageQuantityItem.js';
import { QuantityContainer } from './components/QuantityContainer/QuantityContainer.js';

const getSelectedItem = (items, selectedSize)=>{
    const item = items.find(({ value  })=>value === selectedSize
    );
    return item || items[0] || {
        value: '',
        label: ''
    };
};
const PackageQuantityDropdown = ({ label , items , selectedSize , onChange , 'data-t': dataT = 'package-quantity-dropdown' , className ,  })=>{
    const [selected, setSelected] = React.useState(()=>getSelectedItem(items, selectedSize)
    );
    const [isOpen1, setIsOpen] = React.useState(false);
    const title = [
        label,
        selected.label,
        selected.subtext
    ].filter(Boolean).join(' ');
    const dropdownRef = React.useRef(null);
    useOnClickOutside(dropdownRef, ()=>setIsOpen(false)
    );
    const buttonLabel = React.useMemo(()=>/*#__PURE__*/ React.createElement(PackageQuantityItem, swcHelpers.extends({
            className: "package-quantity-dropdown"
        }, selected))
    , [
        selected
    ]);
    const handleSelect = React.useCallback((option)=>{
        setSelected(option);
        setIsOpen(false);
        onChange(option);
    }, []);
    const handleClick = React.useCallback(()=>{
        setIsOpen((isOpen)=>!isOpen
        );
    }, []);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            event.stopPropagation();
            setIsOpen(false);
        }
    };
    React.useEffect(()=>{
        setSelected(getSelectedItem(items, selectedSize));
    }, [
        setSelected,
        items,
        selectedSize
    ]);
    React.useEffect(()=>{
        const dropdownNode = dropdownRef.current;
        if (isOpen1 && dropdownNode) {
            dropdownNode.addEventListener('keydown', handleKeyDown);
            return ()=>{
                dropdownNode.removeEventListener('keydown', handleKeyDown);
            };
        }
    }, [
        isOpen1
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('package-quantity-dropdown', className),
        ref: dropdownRef,
        "data-t": dataT
    }, Boolean(label) && /*#__PURE__*/ React.createElement("div", {
        className: "package-quantity-dropdown__label"
    }, label), /*#__PURE__*/ React.createElement(ButtonWithDropdown, {
        "aria-label": title,
        label: buttonLabel,
        className: "package-quantity-dropdown__button",
        onClick: handleClick,
        isActive: isOpen1,
        isFullWidth: true
    }, /*#__PURE__*/ React.createElement(QuantityContainer, {
        items: items,
        handleClick: handleSelect,
        selected: selected
    })));
};

export { PackageQuantityDropdown };
//# sourceMappingURL=PackageQuantityDropdown.js.map
